import { useMemo } from "react"

interface UseEnhanceCallbacksArgs<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  CallbacksType extends Record<string, (...args: any) => void>
> {
  callbacks: CallbacksType
  onAction?: () => void
}

export function useEnhanceCallbacks<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  CallbacksType extends Record<string, (...args: any) => void>
>({ callbacks, onAction }: UseEnhanceCallbacksArgs<CallbacksType>) {
  return useMemo(
    () =>
      Object.fromEntries(
        Object.entries(callbacks).map(([key, fn]) => [
          key,
          (...args: Parameters<typeof fn>) => {
            fn(...args)
            onAction?.()
          }
        ])
      ) as unknown as CallbacksType,
    [callbacks, onAction]
  )
}
